import { combineReducers, createStore, compose, applyMiddleware } from 'redux'
import { routeReducer, syncHistory } from 'react-router-redux'
import { browserHistory } from "react-router";
import thunk from 'redux-thunk'
import {forms, FormState} from '../reducers'
import { createLogger } from 'redux-logger'
import {Store} from "react-redux";

export type RootState = {
    routing: any,
    forms: FormState
}

const logger = createLogger();
const reduxRouterMiddleware = syncHistory(browserHistory);
const rootReducer = combineReducers<RootState>({
    routing: routeReducer,
    forms: forms
});

let store : Store<RootState>;

if(process.env.NODE_ENV === 'production') {
    store = createStore(rootReducer, compose(applyMiddleware(thunk, reduxRouterMiddleware)));
} else {
    store = createStore(rootReducer, compose(applyMiddleware(thunk, reduxRouterMiddleware, logger)));
}

export { store };
